import {
  getTableData,
  getAllAuth,
  getDetails,
  saveRole,
  updateRole,
  filterRole,
  findFilterRoles
} from '@/axios/api/role'
import { Message } from 'element-ui'

const UPDATE_TABLEDATA = 'UPDATE_TABLEDATA'
const UPDATE_TBL_LOADING = 'UPDATE_TBL_LOADING'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_PARAMS = 'UPDATE_PARAMS'
const UPDATE_DET_LOADING = 'UPDATE_DET_LOADING'
const UPDATE_DETAILS = 'UPDATE_DETAILS'
const CLEAR_CHECKED = 'CLEAR_CHECKED'
const UPDATE_SEARCH = 'UPDATE_SEARCH'
const UPDATE_BASE_INFO = 'UPDATE_BASE_INFO'
const UPDATE_CHECKED = 'UPDATE_CHECKED'

const state = {
  tableData: [],
  tblLoading: false,
  detailLoading: false,
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  params: {
    name: '',
    status: '',
    updateTime: [],
    createTime: []
  },
  details: {
    frontEnd: [],
    backEndSys: [],
    appList: [],
    download: [],
    display: [],
    BASFProductDisplay: [],
    power: [],
    pcList: []
  },
  checkedList: {
    beCheckedList: [],
    userCheckedList: [],
    downloadCheckedList: [],
    dpCheckedList: [],
    powerCheckedList: []
  },
  baseInfo: {
    id: '',
    name: '',
    dataStatus: '',
    createByAdmin: '',
    remark: '',
    describe: ''
  }
}

function getFrontEnd (arr) {
  let tempArr = [ ...arr ]
  let hasChildren = []
  let noChildren = []
  tempArr.forEach(v => {
    let item = { ...v }
    item.permission = item.permission || false
    if (item.nodeMenuList && item.nodeMenuList.length) {
      item.nodeMenuList = item.nodeMenuList.map(child => {
        return { ...child, permission: child.permission || false }
      })
      hasChildren.push(item)
    } else {
      noChildren.push(item)
    }
  })
  return { hasChildren, noChildren }
}

function getType (id) {
  let type = ''
  switch (id) {
    case 69:
      type = '(DM)'
      break
    case 36:
      type = '(DU)'
      break
    case 37:
      type = '(DR)'
      break
  }
  return type
}

const getters = {
  tableData: state => state.tableData.map(v => {
    return {
      ...v,
      frontEnd: v.pcList && v.pcList.length
        ? v.pcList.map(item => item.name).join(', ') : [],
      userManage: v.manageList && v.manageList.length
        ? v.manageList.map(item => item.name).join(', ') : [],
      dataManage: v.uploadList && v.uploadList.length
        ? v.uploadList.map(item => item.name + getType(item.parentId)).join(', ') : [],
      appManage: v.appList && v.appList.length
        ? v.appList.map(item => item.name).join(', ') : [],
      downloadAuthority: v.downResourceList && v.downResourceList.length
        ? v.downResourceList.map(item => item.name).join(', ') : [],
      displayAuthority: v.displayResourceList && v.displayResourceList.length
        ? v.displayResourceList.map(item => item.name).join(', ') : []
    }
  }),
  tblLoading: state => state.tblLoading,
  pager: state => state.pager,
  params: state => state.params,
  detailLoading: state => state.detailLoading,
  frontEnd: state => getFrontEnd(state.details.frontEnd || []),
  user: state => state.details.user,
  appList: state => state.details.appList,
  backEndSys: state => state.details.backEndSys,
  download: state => state.details.download,
  display: state => state.details.display,
  BASFProductDisplay: state => state.details.BASFProductDisplay,
  AppBASFProductDisplay: state => state.details.AppBASFProductDisplay,
  power: state => state.details.power,
  checkedList: state => state.checkedList,
  baseInfo: state => state.baseInfo,
  pcList: state => state.details.pcList,
  seeList: state => state.details.seeList
}

const mutations = {
  [UPDATE_TABLEDATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_TBL_LOADING] (state, tblLoading) {
    state.tblLoading = tblLoading
  },
  [UPDATE_TOTAL] (state, total) {
    state.pager = { ...state.pager, total }
  },
  [UPDATE_PARAMS] (state, params) {
    state.params = { ...state.params, params }
  },
  [UPDATE_DET_LOADING] (state, detailLoading) {
    state.detailLoading = detailLoading
  },
  [UPDATE_DETAILS] (state, details) {
    state.details = details
  },
  [CLEAR_CHECKED] (state) {
    state.checkedList = {
      // feCheckedList: [],
      beCheckedList: [],
      userCheckedList: [],
      // appCheckedList: [],
      downloadCheckedList: [],
      dpCheckedList: []
    }
  },
  [UPDATE_CHECKED] (state, checkedList) {
    let { hasChildren, noChildren } = { ...getFrontEnd(checkedList.frontEnd || []) }
    let arr = []
    const getIds = arr => arr.filter(v => v.permission).map(item => item.id)
    hasChildren.forEach(v => {
      arr = [ ...arr, ...getIds(v.nodeMenuList) ]
    })
    let beCheckedList = []
    checkedList.backEndSys.forEach(v => {
      beCheckedList = [ ...beCheckedList, ...getIds(v.nodeMenuList) ]
    })
    let userCheckedList = []
    checkedList.user.forEach(v => {
      userCheckedList = [ ...userCheckedList, ...getIds(v.nodeMenuList) ]
    })
    // const feCheckedList = [ ...arr, ...getIds(noChildren) ]
    state.checkedList = {
      // feCheckedList: feCheckedList,
      beCheckedList: beCheckedList,
      userCheckedList: userCheckedList,
      // appCheckedList: getIds(checkedList.appList),
      downloadCheckedList: getIds(checkedList.download),
      dpCheckedList: getIds(checkedList.display),
      powerCheckedList: getIds(checkedList.power),
      seeListCheckedList: getIds(checkedList.seeList)
    }
  },
  [UPDATE_SEARCH] (state, { pager, params }) {
    state.pager = { ...state.pager, ...pager }
    if (params) state.params = params
  },
  [UPDATE_BASE_INFO] (state, baseInfo) {
    state.baseInfo = baseInfo
  }
}

const actions = {
  // 获取列表数据
  async getTableDataApi ({commit}, params) {
    commit(UPDATE_TBL_LOADING, true)
    try {
      let { data: res } = await getTableData(params)
      commit(UPDATE_TABLEDATA, res.records)
      commit(UPDATE_TOTAL, res.total)
    } catch (e) {}
    commit(UPDATE_TBL_LOADING, false)
  },
  // 设置筛选条件
  setParamsApi ({commit}, params) {
    commit(UPDATE_PARAMS, params)
  },
  // functionTypeName 前端: front end 后台: back end 审核: approval 下载: download 展示: display
  async getRoleDetailsApi ({commit}, {type, roleId}) {
    commit(UPDATE_DET_LOADING, true)
    try {
      let list = {}
      if (type === 'add') {
        // 新增请求
        list = await getAllAuth()
        list = list.data
      } else if (type === 'edit') {
        // 编辑请求
        list = await getDetails({ id: roleId })
        const { dataStatus, id, name, createByAdmin, describe, remark } = { ...list.data }
        const unable = list.data.dataStatus === 3
        const data = { dataStatus, name, id, unable, createByAdmin, describe, remark }
        commit(UPDATE_BASE_INFO, data)
        list = list.data
      }
      const authList = {
        frontEnd: list.pcList,
        pcList: list.pcList,
        user: list.manageList,
        backEndSys: list.uploadList,
        appList: list.appList,
        download: list.downResourceList,
        display: list.displayResourceList,
        power: list.superUserList,
        seeList: list.seeResourceList
      }
      commit(UPDATE_DETAILS, {
        ...authList,
        BASFProductDisplay: list.basfProductDetailList,
        AppBASFProductDisplay: list.appBasfProductDetailList
      })
      commit(UPDATE_CHECKED, authList)
    } catch (e) {}
    commit(UPDATE_DET_LOADING, false)
  },
  // 更新勾选
  setRoleDetailsApi ({state, commit}, params) {
    let details = { ...state.details }
    let current = details[params.type]
    if (params.parent) {
      // 二级菜单
      const parentIndex = current.findIndex(v => v.id === params.parent.id)
      const childIndex = current[parentIndex].nodeMenuList.findIndex(v => v.id === params.child.id)
      current[parentIndex].nodeMenuList[childIndex] = params.child
      current[parentIndex].permission = current[parentIndex].nodeMenuList.some(v => v.permission)
    } else {
      // 一级菜单
      const currentIndex = current.findIndex(v => v.id === params.child.id)
      current[currentIndex] = params.child
      if (params.child.nodeMenuList && params.child.nodeMenuList.length) {
        // 有nodeMenuList的一级菜单
        current[currentIndex].nodeMenuList = current[currentIndex].nodeMenuList.map(v => {
          return { ...v, permission: true }
        })
      }
    }
    commit(UPDATE_DETAILS, details)
  },
  clearCheckedApi ({commit}) {
    commit(CLEAR_CHECKED)
  },
  // 保存角色
  async saveRoleApi ({commit}, params) {
    commit(UPDATE_DET_LOADING, true)
    try {
      await saveRole(params)
      commit(UPDATE_DET_LOADING, false)
      Message.success('success')
      return true
    } catch (e) {
      commit(UPDATE_DET_LOADING, false)
      return false
    }
  },
  // 更新角色
  async updateRoleApi ({commit}, params) {
    commit(UPDATE_DET_LOADING, true)
    try {
      await updateRole(params)
      Message.success('success')
      commit(UPDATE_DET_LOADING, false)
      return true
    } catch (e) {
      commit(UPDATE_DET_LOADING, false)
      return false
    }
  },
  // 清空搜索条件
  clearSearchApi ({state, commit}) {
    const pager = {
      ...state.pager,
      current: 1
    }
    const params = {
      ...state.params,
      name: '',
      status: '',
      downloadAuthority: ''
    }
    commit(UPDATE_SEARCH, { pager, params })
  },
  // 设置page
  setPagerApi ({commit}, pager) {
    commit(UPDATE_SEARCH, { pager })
  },
  // 设置baseInfo
  setBaseInfoApi ({commit}, params) {
    commit(UPDATE_BASE_INFO, params)
  },
  async filterRoleApi ({commit}, params) {
    try {
      const { data: res } = await filterRole(params)
      return res
    } catch (e) {
      return []
    }
  },
  async findFilterRolesApi ({commit}, params) {
    try {
      const { data: res } = await findFilterRoles(params)
      return res
    } catch (e) {
      return []
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/groupRole.js